import throttle from 'lodash.throttle';
import { useEffect } from 'react';

export const useObserveScroll = setIsAtPageBottom => {
  useEffect(() => {
    const loadThreshold = 300;
    const handleScroll = throttle(() => {
      setIsAtPageBottom(
        window.innerHeight +
          document.documentElement.scrollTop +
          loadThreshold ===
          document.body.scrollHeight ||
          window.innerHeight + window.scrollY + loadThreshold >=
            document.body.scrollHeight,
      );
    }, 250);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [setIsAtPageBottom]);
};
